<template>
  <div class="info">
     <el-form :model="userinfo" label-width="100px" :rules="rules" v-if="userinfo" v-loading="loading">
       <el-form-item label="真实姓名">
          <el-input placeholder="请输入姓名" v-model="userinfo.nickname"></el-input>
       </el-form-item>
       <el-form-item label="性别">
          <el-radio-group v-model="userinfo.sex">
            <el-radio :label="parseInt(1)">男</el-radio>
            <el-radio :label="parseInt(2)">女</el-radio>
          </el-radio-group>
       </el-form-item>
       <el-form-item label="手机号" prop="phone">
         <el-input placeholder="请输入手机号" v-model="userinfo.phone" disabled></el-input>
       </el-form-item>
       <el-form-item label="邀请链接">
         <el-button type="text">
           <a :href="url + '/#/?code=' + userinfo.code" target="_blank">{{url + "/#/?code=" + userinfo.code}}</a>
         </el-button>
         <el-button type="text" @click="copy">
           复制链接
         </el-button>
       </el-form-item>
       <el-form-item label="注册时间">
          <span>
            {{userinfo.create_time}}
          </span>
       </el-form-item>
       <el-form-item label="当前身份">
          <span>
            {{userinfo.role==1?"普通会员":userinfo.role==2?"VIP会员":"代理"}}
          </span>
          <!-- <el-button type="primary" size="mini" v-if="userinfo.role==1">升级VIP</el-button> -->
       </el-form-item>
  <!--     <el-form-item label="当前余额">
         <span>{{userinfo.blance || "0.00"}}元</span>
         <el-button type="primary" size="mini" @click="tixian">立即提现</el-button>
       </el-form-item> -->
       <el-form-item>
         <el-button type="success" style="margin-top: 30px;width: 200px;" @click="baocun">
           保存信息
         </el-button>
       </el-form-item>
     </el-form>
  </div>
</template>

<script>
    import {mapGetters} from "vuex"
    import { update } from "@/api/gw/user.js"
  export default {
    data(){
      return{
        url:window.location.origin,
         rules:{
           phone: [{ required: true, message: "手机号不能为空", trigger: "blur" }],
         },
         loading:false,
      }
    },
    computed:{
      ...mapGetters(["userinfo"]),
    },
    props:{

    },
    watch:{

    },
    mounted(){
      this.$store.dispatch("getUserInfo");
    },
    methods:{
      async copy() {
        try {
          await navigator.clipboard.writeText(this.url + '/#/?code=' + this.userinfo.code);
          this.$message.success("复制成功！");
        } catch (err) {
          this.$message.error("复制失败，请切换浏览器重试。");
        }
      },
      //修改用户信息
      baocun(){
        this.loading = true
        update({
          memberuser_id:this.userinfo.memberuser_id,
          nickname:this.userinfo.nickname,
          sex:this.userinfo.sex
        }).then(()=>{
           this.$message.success("保存成功");
           this.$store.dispatch("getUserInfo");
        }).finally(()=>{
          this.loading = false
        })
      },
      //提现
      tixian(){
         if(this.userinfo.blance<=0){
           this.$message.error("余额不足");
           return;
         }
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/home/components/info.vue